import React, {useState} from "react"
import {space, VerificationRequest} from "../../compiled";
import {useProfile} from "../../UserProfileProvider";
import {ActionButton} from "../../util/UI/ActionButton";
import {useVerificationRpc} from "../../util/RpcHooks/VerificationRpc";
import ContactMethodType = space.kenko.proto.ContactMethodType;
import {TextSurveyInput} from "../../components/Inputs/TextSurveyInput";
import {SurveyPhoneInput} from "../../components/Inputs/SurveyPhoneInput";
import {formatPhoneNumber} from "react-phone-number-input";

export const MobileNumberVerification = () => {

  const verificationRpc = useVerificationRpc();
  const {profile} = useProfile();

  const [verificationCode, setVerificationCode] = useState<string>('');

  const [phone, setPhone] = useState<string>();

  // If they have a phone number, but want to change it, this allows the user
  // to go back to the first step.
  const [isEditingPhone, setIsEditingPhone] = useState(false);

  // If sent, the verification page is shown.
  const [sentOtp, setSentOtp] = useState(false);

  if (!profile?.mobileNumber || isEditingPhone) {
    return <div className={'SurveySection'}>
      <h3>What is your phone number?</h3>

      <SurveyPhoneInput label={'uh'} value={phone} error={''} onChange={setPhone}/>

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('set_contact_method', new VerificationRequest({
                      type: ContactMethodType.MOBILE_PHONE,
                      value: phone,
                    }), () => setIsEditingPhone(false))}>Save Number</ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

      <div className={'InputHelpText'}>
        By providing your phone number, you agree to receive SMS updates and notifications from Kenko Space LLC (d/b/a
        Kensu). Message and data rates may apply. You can opt out at any time by replying STOP.
      </div>

    </div>
  }

  // There is a mobile number. 
  if (!sentOtp) {
    return <div className={'SurveySection'}>
      <h3>Please confirm your mobile number.</h3>
      <div>We'll send a verification code via SMS to: {formatPhoneNumber(profile?.mobileNumber)}</div>

      <ActionButton rpcState={verificationRpc.rpcState}
                    onClick={() => verificationRpc.send('send_verification', new VerificationRequest({
                      type: ContactMethodType.MOBILE_PHONE,
                      value: profile?.mobileNumber,
                    }), () => setSentOtp(true))}>Send</ActionButton>

      <ActionButton secondary smaller onClick={() => setIsEditingPhone(true)}>Use a different phone
        number</ActionButton>

      {verificationRpc.rpcState.state == 'error' &&
          <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}

    </div>
  }


  return <div className={'SurveySection'}>
    <h3>Please enter the verification code you received.</h3>

    <TextSurveyInput
        inputType={'text'}
        value={verificationCode}
        onChange={v => setVerificationCode(v ?? '')}
        onContinue={() => {
        }}/>

    <ActionButton rpcState={verificationRpc.rpcState}
                  onClick={() => verificationRpc.send('check_verification_code', new VerificationRequest({
                    type: ContactMethodType.MOBILE_PHONE,
                    value: verificationCode,
                  }))}>Verify Number</ActionButton>

    <ActionButton secondary smaller onClick={() => setSentOtp(false)}>Go back</ActionButton>

    {verificationRpc.rpcState.state == 'error' && <div className={'ErrorText'}>{verificationRpc.rpcState.message}</div>}
  </div>
}